import { CloseOutlined, CopyOutlined, QrcodeOutlined } from "@ant-design/icons";
import { ConfigProvider, Drawer, Modal, QRCode, message } from "antd";
import axios from "axios";
import styles from "css/mobile/mypage.module.css";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert, openAlert, openConfirm } from "redux/slices/alertSlice";
import ResDetailInfo from "./resDetailInfo";
import ResPop from "./ResPop";
import ResDetailInfoFile from "./resDetailInfoFile";

/**
 * Version : 1.0
 * 작성일자 : 2025-02-13
 * 작성자 : 김희민
 * 설명 : 모바일 일정카드 예약내용 클릭시 상세팝업
 */
export default function DetailResPop({
  isOpenResDetail,
  openResPop,
  closeResDetail,
  schedule,
  type,
  refresh,
}) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const payload = useSelector((state) => state.user);

  let today = new Date();
  // const containerRef = useRef(null);
  // const getInitialSize = () => containerRef.current?.offsetWidth || 250;

  const [messageApi, contextHolder] = message.useMessage();
  const [dataload, setDataload] = useState(false);
  const [scheduleinfo, setScheduleInfo] = useState({});
  // const [qrSize, setQrSize] = useState(getInitialSize);
  // const [isOpenRes, setIsOpenRes] = useState(false);
  const [openPopqr, setopenPopqr] = useState(false);

  useEffect(() => {
    // console.log(schedule);
    if (schedule.SCHEDULE_ID !== "") {
      let config = {
        params: {
          SCHEDULE_ID: schedule.SCHEDULE_ID,
        },
      };
      axios.get("/schedule/myscheduledetail", config).then((res) => {
        if (res.status === 200) {
          // console.log("DetailResPop ", res.data);
          setScheduleInfo(res.data);
          setDataload(true);
        }
      });
    }
  }, [schedule, isOpenResDetail]);

  const handleDelete = () => {
    let config = {
      params: {
        PROCESS_TYPE: "D",
        // CALENDAR_TYPE: props.PAGE_TYPE === "calendar" ? "MY" : "FULL",
        SCHEDULE_ID: scheduleinfo.SCHEDULE_ID,
        SCHEDULE_TYPE: scheduleinfo.SCHEDULE_TYPE,
        TITLE: scheduleinfo.TITLE,
        RECORD_YN: scheduleinfo.RECORD_YN,
        START_TIME: dayjs(scheduleinfo.START_DATETIME).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        END_TIME: dayjs(scheduleinfo.END_DATETIME).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      },
    };

    axios
      .delete("/schedule/reserve", config)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.DELETE_COMPLETE"),
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          closeResDetail();
          refresh();
        }
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };

  const openRes = (e, type) => {
    e.stopPropagation();
    openResPop(scheduleinfo, type);
    closeResDetail();
  };

  const datetimeConverter = (value) => {
    if (i18n.language === "en-US") {
      return moment(value).locale("en").format("MMMM D, YYYY (ddd) - hh:mm A");
    } else {
      return moment(value).locale("ko").format("YYYY-MM-DD (dd) - a hh:mm");
    }
  };

  const checkjoin = (now, start, end, make) => {
    let nowTime = moment(now);
    let startTime = moment(start);
    let endTime = moment(end);

    let diff = {
      month: moment.duration(startTime.diff(nowTime)).months(),
      day: moment.duration(startTime.diff(nowTime)).days(),
      hour: moment.duration(startTime.diff(nowTime)).hours(),
      minute: moment.duration(startTime.diff(nowTime)).minutes(),
      fin: moment.duration(endTime.diff(nowTime)).minutes(),
    };

    if (diff.fin < 0) {
      return "finish";
    } else {
      if (diff.month < 1 && diff.day < 1 && diff.hour < 1 && diff.minute < 30) {
        return true;
      } else {
        return false;
      }
    }
  };

  const getLeftTime = (startTime) => {
    if (!startTime) {
      // 즐겨찾기 페이지인 경우 시간값 없음
      return { text: "즐겨찾기", className: "favorite" };
    }

    const now = moment();
    const start = moment(startTime);
    const diffMinutes = start.diff(now, "minutes");

    if (diffMinutes < 0) {
      return { text: "진행중", className: "ongoing" };
    }

    if (diffMinutes < 5) {
      return { text: "곧 시작", className: "imminent" };
    }

    if (diffMinutes < 60) {
      return { text: `시작 ${diffMinutes}분 전`, className: "minutes" };
    }

    const diffHours = start.diff(now, "hours");
    if (diffHours < 24) {
      const hours = Math.floor(diffHours);
      const minutes = diffMinutes % 60;

      if (minutes === 0) {
        return { text: `시작 ${hours}시간 전`, className: "hours" };
      }
      return { text: `시작 ${hours}시간 ${minutes}분 전`, className: "hours" };
    }

    const diffMonths = start.diff(now, "months");
    if (diffMonths > 0) {
      return { text: `시작 ${diffMonths}달 전`, className: "months" };
    }

    const diffDays = start.diff(now, "days");

    return { text: `시작 ${diffDays}일 전`, className: "days" };
  };
  const systemtype = useSelector((state) => state.system.isOnline);

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Message: {
              // contentBg: "#000", // Change background color
              // contentColor: "#fff", // Change text color
              // colorText: "#fff",
              colorSuccess: "#29ac8d",
            },
          },
        }}
      >
        {contextHolder}
        {/* <ResPop
          isOpenRes={isOpenRes}
          close={closeRes}
          schedule={{
            ...schedule,
            PROCESS_TYPE: "U",
          }}
          PAGE_TYPE="calendar"
          RES_TYPE="general"
        /> */}
        <Drawer
          open={isOpenResDetail}
          onClose={closeResDetail}
          placement="bottom"
          closable={false}
          maskClosable={false}
          height="auto"
        >
          <Modal
            centered
            // className={styles.qrpop_full} //모달 ClassName
            // className="qrpop-m"
            open={openPopqr}
            onCancel={() => setopenPopqr(false)}
            footer={null}
            width="auto"
          >
            <div className={styles.qrcode_container}>
              <QRCode
                className="qrcode-m"
                errorLevel="H"
                value="https://www.riv-tech.co.kr/neat"
                //icon="https://demo.riv-tech.co.kr/allplace/img/mypage/logo.png"
                //icon="c:\Users\hmkim\Desktop\neat.png"
                icon={process.env.REACT_APP_CLIENT_URL + "neat2.png"}
                iconSize={75}
                size={250}
              />
            </div>
            <div
              style={{
                fontSize: "12px",
                textAlign: "center",
                marginTop: "5px",
              }}
            >
              MEETING URL :<br />
              {scheduleinfo.MEETING_URL}
            </div>
          </Modal>
          <div className={styles.res_detail_container}>
            <div className={styles.header}>
              {type === "current"
                ? t("LABEL.TITLE.MEETING_DETAILS")
                : t("LABEL.TITLE.PAST_MEETING_DETAILS")}
              <button className={styles.closeBtn} onClick={closeResDetail}>
                <CloseOutlined style={{ fontSize: "18px" }} />
              </button>
            </div>

            {type === "current" && (
              <div className={styles.cardHeader}>
                <div
                  className={`${styles.statusBar} ${styles[type]} ${
                    styles[getLeftTime(schedule.START_TIME).className]
                  }`}
                />
              </div>
            )}

            <div className={styles.title}>{scheduleinfo.TITLE}</div>

            <div className={styles.content_wrapper}>
              <div className={styles.content_container}>
                <div className={styles.contents}>
                  <ResDetailInfo
                    index={t("LABEL.MEETING_START")}
                    value={datetimeConverter(scheduleinfo.START_DATETIME)}
                    marginTop={0}
                  />
                  <ResDetailInfo
                    index={t("LABEL.MEETING_END")}
                    value={datetimeConverter(scheduleinfo.END_DATETIME)}
                    marginTop={10}
                  />
                  <ResDetailInfo
                    index={t("LABEL.MEETING_ROOM")}
                    value={
                      dataload &&
                      scheduleinfo.endpointlist &&
                      scheduleinfo.endpointlist
                        .map((item) => item.ENDPOINT_NM)
                        .join(", ")
                    }
                    marginTop={22}
                  />
                  <ResDetailInfo
                    index={t("LABEL.MEETING_HOST")}
                    value={[
                      {
                        ID: scheduleinfo.HOST_KEY,
                        VALUE_1: scheduleinfo.HOST_NM,
                        VALUE_2: scheduleinfo.HOST_EMAIL,
                      },
                    ]}
                    marginTop={22}
                  />
                  <ResDetailInfo
                    index={t("LABEL.MEETING_PTCP")}
                    value={
                      dataload &&
                      scheduleinfo.participantlist &&
                      scheduleinfo.participantlist.map((item) => ({
                        ID: item.MEMBER_ID,
                        VALUE_1: item.MEMBER_NM,
                        VALUE_2: item.EMAIL,
                      }))
                    }
                    marginTop={22}
                  />
                  <ResDetailInfo
                    index={t("LABEL.MEETING_CONTENT")}
                    value={scheduleinfo.CONTENTS}
                    marginTop={22}
                  />
                  <ResDetailInfoFile
                    index={t("LABEL.ATTACHMENT")}
                    value={scheduleinfo}
                    marginTop={22}
                  />
                  {systemtype === false
                    ? ""
                    : type === "current" && (
                        <div
                          className={styles.detailInfo_container}
                          style={{ marginTop: "22px", alignItems: "center" }}
                        >
                          <div className={styles.info_index}>참여링크</div>
                          <div className={styles.info_value}>
                            <div
                              className={styles.detailpop_content_body}
                              style={{ gap: "5px" }}
                            >
                              <CopyToClipboard
                                className={styles.detailpop_content_button}
                                text={scheduleinfo.MEETING_URL}
                                onCopy={() => {
                                  messageApi.open({
                                    type: "success",
                                    content: t("MESSAGE.COPY_COMPLETE"),
                                    // style: {
                                    //   marginTop: "90vh",
                                    // color: "#000",
                                    // },
                                  });
                                }}
                              >
                                <div>
                                  {t("BTN.LINK_COPY")}
                                  <CopyOutlined
                                    style={{
                                      marginLeft: "3px",
                                      fontSize: "15px",
                                    }}
                                  />
                                </div>
                              </CopyToClipboard>
                              <div
                                className={styles.detailpop_content_button}
                                onClick={() => setopenPopqr(true)}
                              >
                                {t("BTN.QR_CODE")}
                                <QrcodeOutlined
                                  style={{
                                    marginLeft: "3px",
                                    fontSize: "15px",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                </div>
              </div>
            </div>

            <div className={styles.footer}>
              {type === "past" ? (
                <button
                  className={`${styles.greenBtn} ${styles.fullBtn}`}
                  onClick={(e) => openRes(e, "C")}
                >
                  {t("BTN.RESERVE_AGAIN")}
                </button>
              ) : scheduleinfo.INPUT_ID === payload.id ? (
                checkjoin(
                  today,
                  scheduleinfo.START_DATETIME,
                  scheduleinfo.END_DATETIME,
                  true
                ) === true ? (
                  systemtype === false ? (
                    ""
                  ) : (
                    <button
                      className={`${styles.greenBtn} ${styles.fullBtn}`}
                      onClick={() => window.open(scheduleinfo.MEETING_URL)}
                    >
                      {t("BTN.ENTER_MEETING")}
                    </button>
                  )
                ) : checkjoin(
                    today,
                    scheduleinfo.START_DATETIME,
                    scheduleinfo.END_DATETIME,
                    true
                  ) === false ? (
                  <>
                    <button
                      className={`${styles.halfBtn} ${styles.greenWhiteBtn}`}
                      onClick={(e) => openRes(e, "U")}
                    >
                      {t("BTN.MODIFY")}
                    </button>
                    <button
                      className={`${styles.halfBtn} ${styles.redWhiteBtn}`}
                      onClick={() => {
                        const obj = {
                          title: t("MESSAGE.NOTIFICATION"),
                          content: t("MESSAGE.DELETE_SCD"),
                          submitEventHandler: () => {
                            handleDelete();
                            dispatch(closeAlert());
                          },
                        };
                        dispatch(openConfirm(obj));
                      }}
                    >
                      {t("BTN.DELETE")}
                    </button>
                  </>
                ) : (
                  <button
                    className={`${styles.greenBtn} ${styles.fullBtn}`}
                    onClick={(e) => openRes(e, "C")}
                  >
                    {t("BTN.RESERVE_AGAIN")}
                  </button>
                )
              ) : (
                <div>
                  {checkjoin(
                    today,
                    scheduleinfo.START_DATETIME,
                    scheduleinfo.END_DATETIME,
                    false
                  ) === true ? (
                    systemtype === false ? (
                      ""
                    ) : (
                      <button
                        className={`${styles.greenBtn} ${styles.fullBtn}`}
                        onClick={() => window.open(scheduleinfo.MEETING_URL)}
                      >
                        {t("BTN.ENTER_MEETING")}
                      </button>
                    )
                  ) : checkjoin(
                      today,
                      scheduleinfo.START_DATETIME,
                      scheduleinfo.END_DATETIME,
                      false
                    ) === false ? (
                    systemtype === false ? (
                      ""
                    ) : (
                      <button
                        className={`${styles.greenBtn} ${styles.fullBtn}`}
                        onClick={() => window.open(scheduleinfo.MEETING_URL)}
                      >
                        {t("BTN.ENTER_MEETING")}
                      </button>
                    )
                  ) : (
                    <button
                      className={`${styles.greyBtn} ${styles.fullBtn}`}
                      onClick={() => window.open(scheduleinfo.MEETING_URL)}
                    >
                      {t("BTN.MEETING_CLOSED")}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </Drawer>
      </ConfigProvider>
    </>
  );
}
